import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeMedicalExamLocaleModule: LocaleModule = {
  name: "employeeMedicalExam",
  messages: { en: en, it: it },
};
